var map = {
	"./discord.svg": 7747,
	"./email.svg": 6084,
	"./github.svg": 6719,
	"./instagram.svg": 8830,
	"./linkedin.svg": 2392,
	"./telegram.svg": 2462,
	"./twitter.svg": 9123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2906;